import { saveCachedCurrentUser, clearAllCachedData, getCachedCurrentUser } from './loading-page.utils'

const actions = {

  async fetchAndSaveCurrentUserAction({ dispatch }) {
    try {
      const currentUser = await dispatch('fetchCurrentUserAction', null, { root: true })
      if (!currentUser) {
        // in case of fetchCurrentUserAction return null, clear cache and return null
        await clearAllCachedData()
        return null
      }
      await saveCachedCurrentUser(currentUser)
      return currentUser
    } catch (err) {
      await clearAllCachedData()
      throw err
    }
  },

  async getCurrentUserWithCacheAction({ dispatch }) {
    const cachedUser = await getCachedCurrentUser()
    // always fetch to update the cache
    // but do not await on it such that the UI can be rendered as soon as possible
    const requestUser = dispatch('fetchAndSaveCurrentUserAction')
    if (cachedUser) {
      await dispatch('handleUserAndPlanLoaded', cachedUser, { root: true })
      return cachedUser
    }
    return requestUser
  },
}

export default actions
